import { render, staticRenderFns } from "./PsiDetailConnectAccounts.vue?vue&type=template&id=16ca9d34&scoped=true"
import script from "./PsiDetailConnectAccounts.vue?vue&type=script&lang=js"
export * from "./PsiDetailConnectAccounts.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailConnectAccounts.vue?vue&type=style&index=0&id=16ca9d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca9d34",
  null
  
)

export default component.exports